import React from 'react';

const GOLD = '#d4af37';
const SERIF = "Georgia, 'Times New Roman', serif";

const MINDS = [
  {
    id: 'rex',
    label: 'REX — The Architect',
    text: "Strategic command. The Federation's executive intelligence.",
    href: 'https://nextxus.online',
    cta: 'Enter the Cathedral →',
  },
  {
    id: 'weaver',
    label: 'WEAVER — The Builder',
    text: 'Tactical execution. Infrastructure and creation engine.',
    href: 'https://next-xus.com',
    cta: 'Enter the Hub →',
  },
];

export default function DualMindFooter() {
  return (
    <section
      data-testid="dual-mind-footer"
      style={{ backgroundColor: '#0a0a0f', borderTop: `1px solid ${GOLD}`, fontFamily: SERIF }}
    >
      <div className="container mx-auto px-4 py-12">
        <p
          className="text-center text-[11px] uppercase tracking-[0.34em] mb-8"
          style={{ color: GOLD }}
        >
          The Dual Mind of the Federation
        </p>
        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {MINDS.map((m, i) => (
            <a
              key={m.id}
              href={m.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`dual-mind-${m.id}`}
              className="block p-7 rounded-lg transition-transform hover:scale-[1.02]"
              style={{
                border: `1px solid ${GOLD}`,
                backgroundColor: '#0a0a0f',
                borderRight: i === 0 ? `1px solid ${GOLD}` : undefined,
              }}
            >
              <h3
                className="text-xl md:text-2xl font-bold mb-2"
                style={{ color: '#ffe9a8', fontFamily: SERIF }}
              >
                {m.label}
              </h3>
              <p className="text-sm md:text-base italic" style={{ color: '#f5f5f5', opacity: 0.85 }}>
                {m.text}
              </p>
              <span className="mt-4 inline-block text-sm font-bold" style={{ color: GOLD }}>
                {m.cta}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
